import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import AssignTechnicianToAssessment, {
    AssignTechnicianToAssessmentProps
} from "../../../pages/consumers/assessments/components/AssignTechnicianToAssessment";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AssignTechnicianToAssessmentProps {
}

type Props = OwnProps;

// @ts-ignore
const AssignTechnicianToAssessmentModal = NiceModal.create<Props>(({assessment, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver title={header} onClose={handleClose} open={modal.visible} afterClose={modal.remove}>
            <AssignTechnicianToAssessment assessment={assessment}/>
        </SlideOver>
    )
})

export default AssignTechnicianToAssessmentModal;
